module.exports = __webpack_public_path__ + "assets/img/btn-detail-e5cebeb6.png";